import styled from "styled-components";
import { COLORS } from "../../../constants/variables";

const pageBg = require("../../../images/newsview-bg-red.png");
const pageBgMobile = require("../../../images/newsview-bg-red-mobile.png");
const topBanner = require("../../../images/ge-top-banner.png");
const bottomBanner = require("../../../images/ge-bottom-banner.png");

const tableSpacing = -12;

export const PageWrapper = styled("div")`

 .translate-position-100{
    margin-top: -100px;
 }

 .translate-position-150{
    margin-top: -100px;

    @media screen and (max-width: 900px) {
      margin-top: -150px;
    }
  }

 .notification-banner-wrapper{
   margin-bottom: 40px;
 }

  > .wrapper {
    display: flex;
    align-items: center;
  }
  .header {
    //height: 360px;
    padding: 50px 0;
    min-height: 570px;
    background: url(${(props) => (props.background ? props.background : pageBg)})
      top / cover no-repeat;
    display: flex;
    align-items: center;
    text-align: left;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
    @media screen and (max-width: 900px) {
      background: url(${(props) => (props.backgroundMobile ? props.backgroundMobile : pageBgMobile)})
        top / cover no-repeat;
    }
    &.has-feature {
      padding: 50px 0 90px;
    }
    &.shorter {
      min-height: initial;
    }
    .wrapper {
      display: flex;
      align-items: center;
    }
    &.page-view {
      @media screen and (max-width: 900px) {
        padding: 50px 0 130px;
      }

      &.has-banner{
        @media screen and (max-width: 767px) {
          padding: 50px 0 94vw;
        }

        @media screen and (max-width: 412px) {
          padding: 50px 0 50vh;
        }
      }
    }
    &.special-cancercareprime {
      @media screen and (max-width: 900px) {
        padding: 50px 0 180px;
      }
    }
    .header-content {
      width: 100%;
    }
    .back-btn {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      outline: none;
      border: 2px solid #102938;
      background-color: transparent;
      margin-bottom: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      > svg {
        fill: #102938;
        font-size: 1rem;
      }
    }
    .header-content-wrapper {
      display: flex;
      align-items: flex-start;
      @media screen and (max-width: 900px) {
        flex-flow: row wrap;
      }
      .header-icon {
        height: 150px;
        &.big-icon {
          min-width: 320px;
          height: auto;
          @media screen and (max-width: 900px) {
            min-width: 100%;
          }
        }
        @media screen and (max-width: 900px) {
          width: 100%;
          height: auto;
        }
      }
    }
    .header-text {
      width: 50%;
      @media screen and (max-width: 900px) {
        width: 100%;
      }
      .sub-title {
        margin: 0;
        color: ${(props) => (props.isViewPage ? "#102938" : `${COLORS.primaryRed}`)};
        font-weight: bold;
        text-transform: uppercase;
        font-size: 1rem;
        display: flex;
        align-items: center;
        @media screen and (max-width: 900px) {
          flex-flow: row wrap;
          display: block;
        }
        .sub-title-tag {
          padding: 6px 16px;
          border-radius: 25px;
          background: #05a0d3;
          color: #fff;
          font-size: 0.6875rem;
          text-transform: uppercase;
          margin-left: 16px;
          @media screen and (max-width: 900px) {
            margin-left: 0;
            display: table;
            margin-top: 10px;
          }

          &.pink{
            background-color: #d72264;
          }
        }
      }
      .title {
        margin: 0;
        font-weight: 500;
        color: ${COLORS.primaryBlack};
        font-size: 3.125rem;
        display: flex;
        align-items: flex-end;
        img {
          height: 65px;
          width: auto;
          margin: 0 10px;
          box-sizing: content-box;
          //padding-bottom: 12px;
        }
      }
      .content {
        color: ${COLORS.primaryBlack};
        font-size: 1.3125rem;
        margin-bottom: 20px;
        p {
          margin-bottom: 24px;
        }
        .social-icons {
          color: ${COLORS.primaryBlack};
          display: flex;
          align-items: center;
          margin: 10px 0;
          font-size: 12px;
          font-weight: bold;
          text-transform: uppercase;
          @media screen and (max-width: 900px) {
            flex-flow: row wrap;
            justify-items: center;
            text-align: center;
          }
          .share-description {
            display: inline-flex;
            p {
              margin: 0;
            }
          }
          button {
            cursor: pointer;
            color: ${COLORS.primaryBlack};
            outline: none;
            border: 0;
            background: transparent;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0;
            padding: 0;
          }
          svg {
            margin: 0 4px;
          }
        }
        .partnership-info-wrapper {
          display: flex;
          margin-top: 35px;
        }
        .partnership-info {
          display: flex;
          align-items: center;
          flex-direction: column;
          margin-right: 20px;
          > span {
            font-size: 1.125rem;
            color: ${COLORS.primaryBlack};
            font-weight: bold;
            margin-bottom: 8px;
          }
          > img {
            margin: auto;
            max-width: 120px;
            @media screen and (max-width: 900px) {
              width: 80px;
            }
          }
        }
      }
      .action-btn {
        display: inline-flex;
        justify-content: center;
        align-items: center;
        text-decoration: none;
        background-color: ${({ ctaColor }) => (ctaColor || "#ea0029")};
        border-radius: 4px;
        height: 40px;
        border: 0;
        outline: none;
        font-size: 12px;
        text-transform: uppercase;
        color: #fff;
        font-weight: bold;
        box-shadow: 0 3px 6px rgba(0, 0, 0, 0.29);
        padding: 0 55px;
        margin-right: 20px;
        white-space: nowrap;
        transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
        @media not all and (hover: none) {
          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.29);
          }
        }
        @media screen and (max-width: 900px) {
          width: 100%;
          margin-right: 0;
          margin-bottom: 20px;
        }
      }
    }
    .header-logo {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      > img {
        width: 60%;
      }
    }
  }

  .view-feature-wrapper {
    background: #fff;
    padding: 40px 0;
    border-radius: 8px;
    box-shadow: 0 3px 16px rgba(0, 80, 122, 0.16);
    display: flex;
    align-items: flex-start;
    justify-items: center;
    width: 100%;
    @media screen and (max-width: 900px) {
      flex-flow: row wrap;
    }
    .view-feature-item {
      width: 200px;
      margin: 0 auto;
      @media screen and (max-width: 900px) {
        width: 45%;
      }
      > img {
        max-width: 50px;
      }
      .view-feature-title {
        color: ${COLORS.primaryBlack};
        font-size: 0.75rem;
        margin: 0;
        font-weight: 400;
      }
      .view-feature-desc {
        color: ${COLORS.primaryBlack};
        font-size: 0.75rem;
        margin: 0;
      }
    }
  }

  .child-title-wrapper {
    margin-top: 80px;
    .sub-title {
      margin: 0;
      color: ${(props) => (props.isViewPage ? "#102938" : "#05a0d3")};
      //font-weight: 400;
      text-transform: uppercase;
      font-size: 1rem;
      display: flex;
      align-items: center;
      @media screen and (max-width: 900px) {
        flex-flow: row wrap;
      }
    }
    .title {
      text-align: left;
      margin: 5px 0 0 0;
      font-weight: 400;
      color: ${COLORS.primaryBlack};
      font-size: 3.125rem;
      display: flex;
      align-items: flex-end;
      img {
        height: 50px;
        width: auto;
        margin: 0 10px;
        box-sizing: content-box;
        //padding-bottom: 12px;
      }
    }
  }

  .child-selector-wrapper {
    width: 100%;
    position: relative;
    background-color: ${({ tertiaryColor }) => (tertiaryColor || "#102938")};
    position: -webkit-sticky; /* Safari */
    position: sticky;
    top: 58px;
    z-index: 90;

    .wrapper {
      padding: 50px 0;
      @media screen and (max-width: 900px) {
        padding: 5% 5%;
      }

      &-selection {
        padding-top: 5px;
        padding-bottom: 5px;
      }

      .child-selector-menu {
        justify-content: space-between;
        display: flex;
        flex-direction: row;
        width: 100%;

        @media screen and (max-width: 900px) {
          display: none;
        }

        button {
          flex: 1;
          margin: 10px;
          border-radius: 12px;
          border-color: transparent;
          background-color: white;
          color: ${COLORS.primaryBlack};
          padding: 8px;
          font-size: 0.75rem;
        }

        .selected {
          background-color: ${({ mainColor }) => (mainColor || "#102938")};
          color: white;
          font-weight: bold;
        }

        .child-selector-dropdown {

        }
      }

      .child-selector-menu-mobile {
        width: 100%;
        position: relative;
        list-style: none;
        padding-inline-start: 0;
        display: none;

        @media screen and (max-width: 900px) {
          display: block;
        }

        button {
          padding: 12px;
          width: 100%;
          font-weight: bold;
          border-radius: 12px;
          font-size: 12px;
          border-color: transparent;
          background-color: ${({ mainColor }) => (mainColor || "#102938")};
          color: white;
        }

        .arrow {
          border: solid white;
          border-width: 0 2px 2px 0;
          display: inline-block;
          width: 12px;
          height: 12px;
          float: right;
          margin-top: -2px;
          margin-right: 5px;
        }

        .down {
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
        }

        ul {
          background: #ddd;
          height: 0;
          left: 0;
          opacity: 0;
          position: absolute;
          transition: all .3s ease;
          top: 43px;
          width: 100%;
          list-style: none;
          padding-inline-start: 0;
        }

        .opened {
          height: auto;
          opacity: 1;
          transform: translateY(0);
          z-index: 100;
        }

        ul button {
          padding: 12px;
          width: 100%;
          font-weight: bold;
          font-size: 12px;
          border-color: transparent;
          background-color: white;
          color: ${COLORS.primaryBlack};
          border-radius: 0;
        }
      }

      h3 {
        text-transform: uppercase;
        font-size: 0.875rem;
        color: #ea0029;
        text-align: left;
      }
      .child-selector-btn-wrapper {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        .child-selector-grid {
          width: 66%;
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-between;
          @media screen and (max-width: 900px) {
            width: 100%;
          }
        }
        .child-selector-btn {
          background-color: white;
          position: relative;
          border-radius: 17px;
          padding: 10px 15px;
          width: calc(50% - 10px);
          margin-bottom: 20px;
          @media screen and (max-width: 600px) {
            width: 100%;
          }
          .child-selector-btn-title {
            display: flex;
            flex-direction: row;
          }
          .steps-tooltip {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 12px;
            height: 12px;
            border-radius: 50%;
            border: 1px solid #102938;
            font-size: 0.4em;
            margin-top: 49px;
            @media screen and (max-width: 900px) {
              margin-top: 45px;
            }
            margin-left: 10px;
            position: relative;
            cursor: pointer;
            &:hover {
              .steps-tooltip-content {
                opacity: 1;
                visibility: visible;
              }
            }
            .steps-tooltip-content {
              position: absolute;
              background-color: white;
              width: 200px;
              color: ${COLORS.primaryBlack};
              font-size: 14px;
              line-height: 20px;
              padding: 16px;
              left: 0;
              top: -16px;
              transform: translateX(calc(-100% - 16px));
              text-align: left;
              border-radius: 10px;
              opacity: 0;
              visibility: hidden;
              transition: opacity 300ms;
              box-shadow: 0px 0px 10px #DDDDDD;
              z-index: 10;
                left: 50% !important;
                transform: translateX(-50%) !important;
                top: 32px !important;
              &.right {
                left: initial;
                right: 0;
                transform: translateX(calc(100% + 16px));
                &:before {
                  border-left-color: transparent;
                  border-right-color: #ffa225;
                  left: -20px;
                  right: initial;
                }
              }

              ul {
                margin: 0;
                padding: 12px 0 12px 16px;
              }

              p {
                font-size: 0.75rem;
                color: ${COLORS.primaryBlack};
                text-align: left;
                font-weight: 500;
              }
            }
          }
          h4 {
            padding-top: 30px;
            margin-bottom: 0.3em;
            font-size: 0.75rem;
            color: ${COLORS.primaryBlack};
            text-align: left;
          }
          p {
            font-size: 0.75rem;
            color: ${COLORS.primaryBlack};
            text-align: left;
          }
          &-small {
            img {
              height: 100%;
              width: auto;
              position: absolute;
              top: 0;
              right: 0;
            }
          }
          &-large {
            width: 100%;
            height: auto;
            h4 {
              padding-top: 178px;
              @media screen and (max-width: 900px) {
                padding-top: 100px;
              }
            }
            .steps-tooltip {
              margin-top: 197px;
              @media screen and (max-width: 900px) {
                margin-top: 115px;
              }
            }
            img {
              height: auto;
              width: 100%;
              position: absolute;
              top: 0;
              right: 0;
              @media screen and (max-width: 900px) {
                height: 120px;
                width: auto;
              }
            }
          }
        }
        .child-selector-btn-large-wrapper {
          width: calc(33% - 20px);
          margin-left: 20px;
          @media screen and (max-width: 900px) {
            width: 100%;
            margin-left: 0px;
          }
        }
      }
    }
  }

  .details-banner {
    display: block;
    margin-top: -70px;
    padding-bottom: 70px;
    > img {
      width: 100%;
    }
  }

  .long-banner {
    display: block;
    margin-top: 70px;
    > img {
      width: 100%;
    }
  }

  .become-partner {
    height: 310px;
    display: flex;
    align-items: center;
  }

  .mobile-cta-fixed{
    display: none;
    background-color: white;
    padding: 20px;
    position: fixed;
    bottom:0;
    left:0;
    right:0;
    border-radius: 10px 10px 0 0;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.29);

    @media screen and (max-width:900px){
      display: block;
    }

    .action-btn{
      display: inline-flex;
      width: 100%;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      background-color: ${({ ctaColor }) => (ctaColor || "#ea0029")};
      border-radius: 4px;
      height: 40px;
      border: 0;
      outline: none;
      font-size: 12px;
      text-transform: uppercase;
      color: #fff;
      font-weight: bold;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.29);
      padding: 0 55px;
      margin-right: 20px;
      white-space: nowrap;
      transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
      @media not all and (hover: none) {
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.29);
        }
      }
    }
  }


  .mt-5{
    margin-top: 20px
  }
`;

export const ProductsWrapper = styled("div")`
  padding-top: 80px;
  background-color: ${(props) => (props.scheme ? props.scheme.backgroundColor : "#102938")};
  padding-bottom: 40px;
  .top-banner {
    display: block;
    height: 468px;
    margin: -300px 0 60px;
    background: url(${topBanner}) center / contain no-repeat;
    text-align: left;
    padding: 60px 0 60px 40px;
    position: relative;
    text-decoration: none;
    filter: drop-shadow(0 0 16px rgba(0, 0, 0, 0.4));
    @media screen and (max-width: 900px) {
      padding: 20px 20px 80%;
      height: auto;
      background: #fff url(${topBanner}) right bottom / 200% auto no-repeat;
      border-radius: 8px;
    }
    .top-banner-icons {
      width: 40%;
      margin-top: 40px;
      @media screen and (max-width: 900px) {
        margin-top: 0;
        width: 50%;
      }
    }
    .top-banner-title {
      font-size: 2.625rem;
      font-weight: normal;
      color: #d80022;
      width: 40%;
      margin: 0 0 20px;
      @media screen and (max-width: 900px) {
        width: 100%;
      }
    }
    .top-banner-desc {
      font-size: 1.125rem;
      color: #00476d;
      width: 55%;
      margin: 0;
      @media screen and (max-width: 900px) {
        width: 100%;
      }
    }
    .action-btn {
      height: 40px;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #d80022;
      background-color: #fff;
      font-weight: bold;
      text-transform: uppercase;
      display: inline-flex;
      padding: 0 30px;
      border-radius: 4px;
      border: 1px solid #d80022;
      text-decoration: none;
      transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0s;
      position: absolute;
      bottom: 65px;
      right: 95px;
    }
  }
  .bottom-banner {
    display: block;
    text-decoration: none;
    height: 418px;
    background: url(${bottomBanner}) center / cover no-repeat;
    box-shadow: 0 0 16px rgba(0, 0, 0, 0.4);
    border-radius: 12px;
    position: relative;
    color: #fff;
    display: flex;
    align-items: center;
    justify-items: center;
    @media screen and (max-width: 900px) {
      padding: 20px 20px 80%;
      height: auto;
      background: #d20013 url(${bottomBanner}) left bottom / 200% auto no-repeat;
      border-radius: 8px;
    }
    .text-content {
      width: 50%;
      margin-left: auto;
      padding-right: 40px;
      padding-left: 40px;
      text-align: left;
      @media screen and (max-width: 900px) {
        width: 100%;
        padding: 0;
      }
    }
    .bottom-banner-icons {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 80px;
      @media screen and (max-width: 900px) {
        width: 60px;
      }
    }
    .bottom-banner-subtitle {
      text-transform: uppercase;
      font-size: 1.1rem;
      margin: 0;
    }
    .bottom-banner-title {
      font-size: 2.375rem;
      margin: 0;
      font-weight: normal;
    }
    .bottom-banner-desc {
      font-size: 1rem;
      margin: 20px 0;
    }
    .action-btn {
      height: 40px;
      margin-bottom: 20px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 0 30px;
      font-size: 12px;
      color: #d20013;
      background-color: #fff;
      border-radius: 4px;
      font-weight: bold;
      text-transform: uppercase;
      border: 0;
      text-decoration: none;
    }
    .bottom-banner-helper {
      font-size: 0.625rem;
      margin: 0;
    }
  }
  .title {
    margin: 0 0 45px;
    color: ${(props) => (props.scheme
    ? props.scheme.subColor
      ? props.scheme.subColor
      : props.scheme.color
    : "#fff")};
    font-size: 2.375rem;
    font-weight: bold;
    text-align: left;
    display: flex;
    align-items: center;
    @media screen and (max-width: 900px) {
      display: block;
      margin-bottom: 80px;
    }
    &.product {
      @media screen and (max-width: 900px) {
        margin-bottom: 20px;
      }
    }
    .extra-icon {
      margin-left: auto;
      color: ${COLORS.primaryBlack};
      font-size: 0.75rem;
      display: flex;
      align-items: center;
      @media screen and (max-width: 900px) {
        margin-left: 0;
        margin-top: 10px;
      }
      > img {
        margin-left: 10px;
        max-width: 80px;
      }
    }
  }
  .sub-title {
    color: ${(props) => (props.scheme
    ? props.scheme.subColor
      ? props.scheme.subColor
      : props.scheme.color
    : "#fff")};
    font-size: 1.75rem;
    font-weight: 400;
    text-align: left;
    margin: 0 0 20px;
  }

  .feature-wrapper {
    display: flex;
    align-items: center;
    padding-bottom: 80px;
    @media screen and (max-width: 900px) {
      flex-flow: row wrap;
      padding-bottom: 40px;
    }
    .feature-image {
      height: 310px;
      flex-basis: 745px;
      margin-right: 30px;
      //background-color: #ccc;
      background-size: cover;
      background-position: center;
      border-radius: 8px;
      box-shadow: 0 0 21px rgba(0, 0, 0, 0.2);
      @media screen and (max-width: 900px) {
        height: 150px;
        margin-right: 0;
        margin-bottom: 40px;
      }
      @media screen and (min-width: 900px) and (max-width: 1120px) {
        flex-basis: 50%;
      }
    }
    .feature-text {
      flex-basis: 30%;
      text-align: left;
      @media screen and (max-width: 900px) {
        flex-basis: 100%;
      }
      @media screen and (min-width: 900px) and (max-width: 1120px) {
        flex-basis: 50%;
      }
      .media-sub-title {
        color: ${(props) => (props.scheme.subColor ? props.scheme.subColor : "#FFF")};
        font-size: 1rem;
        font-weight: bold;
        text-transform: uppercase;
        margin-bottom: 12px;
      }
      .media-title {
        font-size: 1.75rem;
        color: ${(props) => (props.scheme ? props.scheme.color : "#fff")};
        margin-bottom: 12px;
      }
      .media-content {
        color: ${(props) => (props.scheme ? `${COLORS.primaryGray}` : "#fff")};
        font-size: 1rem;
        margin-bottom: 12px;
      }
      .read-more {
        color: ${(props) => (props.scheme.subColor ? props.scheme.subColor : props.scheme.color)};
        display: inline-flex;
        align-items: center;
        font-size: 0.875rem;
        &:hover {
          > svg {
            transform: translateX(12px);
          }
        }
        > svg {
          margin-left: 12px;
          font-size: 30px;
          transition: transform 200ms cubic-bezier(0.4, 0, 0.2, 1);
        }
      }
    }
  }
  &.second-product-wrapper{
    padding-bottom: 150px;

    @media screen and (max-width: 900px) {
      padding-bottom: 100px;
    }
  }
`;

export const ProductContent = styled("div")`
  display: flex;
  padding: 70px 0;
  width: 100%;
  align-items: flex-start;
  @media screen and (max-width: 900px) {
    flex-flow: row wrap;
  }
  .left-wrapper {
    flex: 1 1 auto;
    margin-right: 80px;
    @media screen and (max-width: 900px) {
      margin-right: 0;
    }
    .title {
      font-size: 1.3125rem;
      text-align: left;
      text-transform: uppercase;
      color: ${({ mainColor }) => (mainColor || "#ea0029")};
    }

    .sub-section-wrapper {
      margin-bottom: 80px;
      .sub-section-item {
        display: flex;
        @media screen and (max-width: 900px) {
          flex-flow: row wrap;
        }
        &:not(:last-child) {
          margin-bottom: 80px;
        }
        .sub-section-item-image {
          flex-basis: 35%;
          @media screen and (max-width: 900px) {
            flex-basis: 100%;
            margin-bottom: 40px;
          }
          & + .sub-section-item-content {
            text-align: left;
            margin-right: 0;
            margin-left: 30px;
            @media screen and (max-width: 900px) {
              margin-left: 0;
              margin-bottom: 0;
            }
          }
          > .image {
            width: 100%;
            position: relative;
            //height: 180px;
            //background-color: #eee;
            > img {
              width: 100%;
            }
            //&:before {
            //  content: "";
            //  position: absolute;
            //  right: -20px;
            //  bottom: -20px;
            //  width: 140px;
            //  height: 140px;
            //  background-color: #305cff;
            //  z-index: -1;
            //}
          }
        }
        .sub-section-item-content {
          flex-basis: 65%;
          color: ${COLORS.primaryBlack};
          text-align: right;
          margin-right: 30px;
          @media screen and (max-width: 900px) {
            flex-basis: 100%;
            margin-right: 0;
            margin-bottom: 40px;
          }
          //& + .sub-section-item-image {
          //  > .image {
          //    top: 20px;
          //    left: 20px;
          //    &:before {
          //      bottom: initial;
          //      right: initial;
          //      left: -20px;
          //      top: -20px;
          //    }
          //  }
          //}
          h3 {
            margin: 0 0 8px;
            text-transform: uppercase;
            font-size: 1.3125rem;
            color: ${({ mainColor }) => (mainColor || "#ea0029")};
          }
          p {
            margin: 0;
            font-size: 1rem;
          }
          a {
            color: ${COLORS.primaryBlack};
          }
        }
      }
    }

    .key-benefits-wrapper {
      display: flex;
      flex-flow: row wrap;
      .key-benefits-item {
        flex-basis: 40%;
        text-align: left;
        color: ${COLORS.primaryBlack};
        margin-bottom: 40px;
        @media screen and (max-width: 900px) {
          flex-basis: 100%;
        }
        &:nth-child(odd) {
          margin-right: auto;
        }
        img {
          width: 40px;
          height: auto;
          @supports (object-fit: contain) {
            object-fit: contain;
          }
        }
        h3 {
          font-size: 1rem;
          text-transform: uppercase;
          color: ${({ mainColor }) => (mainColor || "#ea0029")};
        }
        p {
          font-size: 0.875rem;
        }
      }
    }

    .tips {
      text-align: left;
      color: ${COLORS.primaryBlack};
      font-size: 0.75rem;
      margin-bottom: 40px;
      display: flex;
      align-items: center;
      @media screen and (max-width: 900px) {
        //flex-flow: row wrap;
      }

      > img {
        //height: 50px;
        @media screen and (max-width: 900px) {
          max-width: 100px;
          height: auto;
        }
      }
    }
  }

  .right-wrapper {
    flex: 0 0 400px;
    background-color: ${({ secondaryColor }) => (secondaryColor || "#F9F8F8")};
    padding: 30px 40px;
    border-radius: 8px;
    @media screen and (max-width: 900px) {
      flex: 0 0 110%;
      margin-left: -5%;
      border-radius: 0;
    }
    .section-item {
      > h3 {
        text-transform: uppercase;
        font-size: 0.875rem;
        margin: 0;
        height: 50px;
        display: flex;
        align-items: center;
        color: ${COLORS.primaryBlue};
        > a {
          margin-left: auto;
          color: ${COLORS.primaryBlue};
        }
      }
      p {
        text-align: left;
        color: ${COLORS.primaryBlue};
        margin: 0;
      }
      ul {
        text-align: left;
        color: ${COLORS.primaryBlue};
        margin: 0;
        padding: 0 0 2rem 1rem;
        li {
          &:not(:last-child) {
            margin-bottom: 1rem;
          }
        }
      }

      > ol {
        list-style: none;
        text-align: left;
        color: ${COLORS.primaryBlue};
        margin: 0;
        padding: 0 0 2rem 1rem;

        > li {
          position: relative;
          font-weight: 600;
          &:before {
            content: "";
            height: 100%;
            width: 2px;
            left: -1rem;
            top: 0;
            bottom: 0;
            background-color: #bacbd4;
            position: absolute;
          }
          &:not(:last-child) {
            margin-bottom: 1.5rem;
          }
          p {
            margin: 0;
            font-size: 0.75rem;
            font-weight: 400;
            ul {
              padding: 0 0 0 1rem;
              list-style: circle;
              li {
                &:not(:last-child) {
                  margin-bottom: 0.25rem;
                }
              }
            }
          }
          a {
            font-size: 0.875rem;
            color: ${COLORS.primaryBlue};
            font-weight: bold;
          }
        }
      }

      .action-btn {
        width: 100%;
        height: 40px;
        margin: 10px 0 0;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        color: rgb(255, 255, 255);
        background-color: ${({ mainColor }) => (mainColor || "#ea0029")};
        font-weight: bold;
        text-transform: uppercase;
        display: inline-flex;
        padding: 0 30px;
        border-radius: 8px;
        border-width: 0;
        border-style: initial;
        border-color: initial;
        border-image: initial;
        text-decoration: none;
        transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1) 0s;
      }
      &:not(:last-of-type) {
        border-bottom: 1px solid #bacbd4;
      }
    }
    .bottom-right-text {
      text-align: right;
      color: ${COLORS.primaryGray};
      font-size: 0.75rem;
      margin-bottom: -80px;
    }
  }
`;

export const ProductTable = styled("div")`
  background-color: ${({ secondaryColor }) => (secondaryColor || "#F9F8F8")};
  padding: 100px 0;

  @media screen and (max-width: 900px) {
    padding: 40px 0;
  }
  .wrapper {
    @media screen and (max-width: 900px) {
      overflow: auto;
    }
  }
  .title-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: 40px;
    @media screen and (max-width: 900px) {
      flex-flow: row wrap;
    }
    h1 {
      margin: 0;
      color: ${({ mainColor }) => (mainColor || "#ea0029")};
      font-size: 3.125rem;
      font-weight: 400;
      margin-right: 10px;
      @media screen and (max-width: 900px) {
        font-size: 2rem;
      }
    }
    .action-btn {
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 30px;
      font-size: 12px;
      color: #fff;
      background-color: ${({ ctaColor }) => (ctaColor || "#ea0029")};
      border-radius: 8px;
      font-weight: bold;
      text-transform: uppercase;
      border: 0;
      display: inline-flex;
      text-decoration: none;
      margin-left: auto;
      transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
      @media screen and (max-width: 900px) {
        margin-left: 0;
        margin-top: 0.5rem;
      }
      @media not all and (hover: none) {
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.29);
        }
      }
    }
  }

  .sub-title {
    font-size: 1rem;
    color: ${({ mainColor }) => (mainColor || "#102938")};
    text-align: left;
    display: flex;
    align-items: center;
  }

  .table-wrapper {
    @media screen and (max-width: 900px) {
      width: 100%;
      overflow: auto;
    }
  }

  table {
    border-collapse: collapse;
    background-color: #fff;
    width: 100% !important;
    &.auto {
      width: auto !important;
    }
    &.select {
      thead {
        tr {
          &:first-child {
            th {
              padding: 20px 20px 20px 40px;
              background-color: #B8362F;
            }
          }
        }
      }
    }
    thead {
      tr {
        padding: 0 40px;
        &:first-child {
          th {
            padding: 20px;
            background-color: #B8362F;
            color: #fff;
            text-align: left;
            text-transform: uppercase;
            &:first-child {
              border-radius: 8px 0 0 0;
            }
            &:last-child {
              border-radius: 0 8px 0 0;
            }
          }
        }
      }
    }
    tbody {
      tr {
        overflow-x: hidden;
        overflow-y: visible;
        &.special {
          td {
            background-color: #459ece;
            color: #fff;
            position: relative;
            text-transform: uppercase;
            font-weight: bold;
            padding-top: 40px;
            z-index: 10;
            &.selected {
              background-color: #68b8db;
              z-index: 10;
              .info {
                opacity: 1;
                transform: translateY(0);
              }
            }
            &:last-child {
              .info {
                right: 20px;
              }
            }
            &:after {
              content: "";
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              background-color: #fff;
              height: 20px;
              z-index: 10;
            }
            .info {
              position: absolute;
              background-color: #eaa943;
              color: #fff;
              border-radius: 8px 8px 0 0;
              left: 0;
              right: 0;
              bottom: 100%;
              font-size: 12px;
              padding: 10px;
              opacity: 0;
              transform: translateY(40px);
              transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
              .price {
                display: block;
                font-size: 16px;
                margin: 4px auto;
                font-weight: bold;
                > span {
                  font-size: 16px;
                  margin: 0;
                  padding: 0;
                }
              }
            }
          }
        }
        &.highlight {
          td {
            background-color: #add4eb;
            &.selected {
              background-color: #c0def0;
            }
          }
          &.red {
            td {
              background-color: #f4b48b;
              color: #fff;
              * {
                color: #fff;
              }
              &.selected {
                background-color: #ff9450;
                color: #fff;
              }
            }
          }
        }
        &.checkbox {
          td {
            text-align: center;
            &:last-child {
              input[type="radio"] {
                right: 20px;
              }
              label {
                right: 20px;
              }
            }
          }
          input[type="radio"] {
            position: absolute;
            top: -20px;
            right: 0;
            bottom: 0;
            left: 0;
            padding: 0;
            margin: auto;
            z-index: 1;
            opacity: 0;
            cursor: pointer;
            width: 100%;
            height: 100%;
            &:checked {
              + label {
                &:before {
                  opacity: 1;
                }
              }
            }
          }
          label {
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 2px solid #eaa943;
            position: absolute;
            top: -20px;
            right: 0;
            bottom: 0;
            left: 0;
            margin: auto;
            z-index: 0;
            &:before {
              content: "";
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 10px;
              height: 10px;
              border-radius: 50%;
              background-color: #eaa943;
              opacity: 0;
            }
          }
          a {
            height: 40px;
            align-items: center;
            justify-content: center;
            padding: 0 30px;
            font-size: 12px;
            color: ${({ ctaColor }) => (ctaColor || "#ea0029")};
            background-color: transparent;
            border: 2px solid
              ${({ ctaColor }) => (ctaColor || "#ea0029")};
            border-radius: 8px;
            font-weight: bold;
            text-transform: uppercase;
            text-decoration: none;
            display: inline-flex;
            &:hover {
              color: #fff;
              background-color: ${({ ctaColor }) => (ctaColor || "#ea0029")};
            }
          }
          &.red {
            a {
              color: #d03836;
              border-color: #d03836;
              &:hover {
                color: #fff;
                background-color: #d03836;
              }
            }
          }
        }
        &.select {
          td {
            background-color: #fff;
            position: relative;
            font-weight: bold;
            padding-top: 30px;
            padding-bottom: 30px;
            z-index: 10;
            vertical-align: middle;
            .select-wrapper {
              display: flex;
              align-items: center;
              > select {
                width: 100%;
                height: 30px;
                border: 1px solid #d03836;
                box-shadow: 0 0 4px rgba(208, 56, 54, 0.56);
                border-radius: 4px;
                outline: none;
                font-family: "Open Sans", sans-serif;
              }
            }
            &:before {
              content: "";
              position: absolute;
              left: 0;
              top: 0;
              background-color: #fff;
              height: 20px;
              z-index: 10;
            }
            &:after {
              content: "";
              position: absolute;
              left: 0;
              right: 0;
              top: 0;
              background-color: #fff;
              height: 20px;
              z-index: 10;
            }
          }
        }
        &.hide {
          display: none;
        }
        &:nth-child(even) {
          td {
            background-color: ${({ secondaryColor }) => (secondaryColor || "#F9F8F8")};
            &.selected {
              background-color: #eff5f8;
              z-index: 10;
            }
          }
        }
        &:last-child {
          td {
            padding-bottom: 40px;
            &:after {
              content: "";
              position: absolute;
              left: 0;
              right: 0;
              bottom: 0;
              background-color: #fff;
              height: 20px;
              z-index: 20;
            }
          }
        }
        &.white {
          td {
            background-color: #fff;
          }
        }
        td {
          font-size: 0.875rem;
          color: ${COLORS.primaryBlue};
          padding: 20px;
          text-align: center;
          position: relative;
          transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
          &.empty,
          &:empty {
            display: none;
          }
          &.tooltip {
            position: relative;
            cursor: default;
            &:hover {
              .tooltip-data {
                opacity: 1;
                visibility: visible;
              }
            }
            &:after {
              content: "ⓘ";
              position: absolute;
              width: 16px;
              height: 16px;
              color: #de773e;
              display: flex;
              align-items: center;
              justify-items: center;
              bottom: 30px;
              left: 0;
              font-weight: bold;
            }
            .tooltip-data {
              position: absolute;
              padding: 10px;
              background-color: #de773e;
              color: #fff;
              border-radius: 8px;
              bottom: 20px;
              left: 0;
              transform: translateX(calc(-100% - 10px));
              opacity: 0;
              visibility: hidden;
              transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
              pointer-events: none;
              &:before {
                content: "";
                position: absolute;
                bottom: 12px;
                right: -4px;
                width: 10px;
                height: 10px;
                background-color: #de773e;
                transform: rotate(45deg);
              }
            }
          }
          &.selected {
            background-color: #f8fcfe;
            box-shadow: -2px 0 2px rgba(0, 0, 0, 0.02),
              -4px 0 2px rgba(0, 0, 0, 0.02), -6px 0 2px rgba(0, 0, 0, 0.02),
              2px 0 2px rgba(0, 0, 0, 0.02), 4px 0 2px rgba(0, 0, 0, 0.02),
              6px 0 2px rgba(0, 0, 0, 0.02);
          }
          &:before {
          }
          &:first-child {
            text-align: left;
            padding-left: 40px;
            &:before {
              content: "";
              position: absolute;
              top: 0;
              left: 0;
              bottom: 0;
              background-color: #fff;
              width: 20px;
            }
          }
          &:last-child {
            padding-right: 40px;
            &.selected {
              box-shadow: -2px 0 2px rgba(0, 0, 0, 0.02),
                -4px 0 2px rgba(0, 0, 0, 0.02), -6px 0 2px rgba(0, 0, 0, 0.02),
                2px 0 2px rgba(0, 0, 0, 0.02);
            }
            &:before {
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              bottom: 0;
              background-color: #fff;
              width: 20px;
            }
          }
          > * {
            display: block;
          }
          b {
            font-weight: bold;
            + br {
              + * {
                margin-top: ${tableSpacing}px;
              }
            }
          }
          strong {
            font-weight: bold;
            + br {
              + * {
                margin-top: ${tableSpacing}px;
              }
            }
          }
          i {
            font-style: initial;
            font-size: 0.625rem;
            + br {
              + * {
                margin-top: ${tableSpacing}px;
              }
            }
          }
          small {
            font-style: initial;
            font-size: 0.625rem;
            + br {
              + * {
                margin-top: ${tableSpacing}px;
              }
            }
          }
          span {
            font-size: 0.625rem;
            display: inline;
            padding-left: 10px;
          }
        }
      }
    }
  }

  .tips {
    text-align: left;
    color: #99b5c5;
    font-size: 0.75rem;
    margin: 20px 0;
    display: flex;
    align-items: center;
  }

  .bottom-tips {
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    .content {
      display: inline-flex;
      align-items: center;
      color: #99b5c5;
      font-size: 0.75rem;
      background-color: #fff;
      padding: 20px;
      @media screen and (max-width: 900px) {
        flex-flow: row wrap;
      }
      > img {
        //height: 50px;
      }
    }
  }

  .action-button-wrapper {
    text-align: left;
    .action-btn {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      background-color: ${({ ctaColor }) => (ctaColor || "#ea0029")};
      border-radius: 4px;
      height: 40px;
      border: 0;
      outline: none;
      font-size: 16px;
      text-transform: uppercase;
      color: #fff;
      font-weight: bold;
      box-shadow: 0 3px 6px rgba(0, 0, 0, 0.29);
      padding: 0 110px;
      margin-right: 20px;
      transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
      @media not all and (hover: none) {
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.29);
        }
      }
      @media screen and (max-width: 900px) {
        width: 100%;
        margin-right: 0;
        margin-bottom: 20px;
      }
    }
  }
`;

export const ProductFooter = styled("div")`
  background-color: #ea0029;
  padding: 50px 0;
  @media screen and (max-width: 900px) {
    padding: 0 0 40px;
  }
`;

const en = require("../../../images/language-en.svg");
const my = require("../../../images/language-my.svg");
const cn = require("../../../images/language-cn.svg");

export const LanguageSwitcher = styled("div")`
  position: fixed;
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  width: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #005b8b;
  border-radius: 0 8px 8px 0;
  z-index: 100;
  height: auto;
  padding: 10px 0;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
  @media screen and (max-width: 900px) {
    top: 100px;
    height: auto;
    transform: translateY(0) scale(0.8);
    transform-origin: left;
  }
  > button {
    cursor: pointer;
    width: 32px;
    height: 32px;
    border: 2px solid transparent;
    outline: none;
    border-radius: 50%;
    position: relative;
    padding-bottom: 24px;
    margin: auto 0 24px 0;
    @media screen and (max-width: 900px) {
      margin: 0;
      pointer-events: none;
      display: none;
    }
    transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
    &.active {
      border: 2px solid #ea0029;
      @media screen and (max-width: 900px) {
        display: block;
      }
      &:before {
        color: #ea0029;
      }
    }
    &:before {
      content: attr(data-text);
      position: absolute;
      height: 20px;
      color: #fff;
      //font-weight: bold;
      text-align: center;
      width: 100%;
      left: 0;
      right: 0;
      bottom: -21px;
      font-size: 0.75rem;
      transition: all 200ms cubic-bezier(0.4, 0, 0.2, 1);
      @media screen and (max-width: 900px) {
        display: none;
      }
    }
    &.my {
      background: url(${my}) center / contain no-repeat;
    }
    &.en {
      background: url(${en}) center / contain no-repeat;
    }
    &.cn {
      background: url(${cn}) center / contain no-repeat;
    }
    &:last-child {
      margin-bottom: 12px;
      @media screen and (max-width: 900px) {
        margin: 0;
      }
    }
  }
`;
